<template>
  <div class="c-show-faq">
    <div class="faq-window">
      <n-card class="faq-card">
        <n-loader :loading="$var('load')" />
        <div class="card-top">
          <n-button flat @click="closeModal">X</n-button>
        </div>
        <div>
          <div class="faq-info">
            <n-items>
              <n-input title="Заголовок Ru" v-bind="$form.input('titleRu')"></n-input>
              <c-textarea title="Содержание Ru" v-bind="$form.input('contentRu')"></c-textarea>
              <n-input title="Заголовок Kz" v-bind="$form.input('titleKz')"></n-input>
              <c-textarea title="Содержание Kz" v-bind="$form.input('contentKz')"></c-textarea>
            </n-items>
          </div>
          <div class="button-save">
            <n-button color="primary" @click="save">Сохранить</n-button>
          </div>
        </div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CShowFaq',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      content: '',
      status: {},
    }
  },
  created() {
    this.load()
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false)
    },
    load() {
      this.$var('load', true)
      $api.faqs.get(this.id).then((response) => {
        this.$form.init(response.data.content)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.faqs.edit(this.id, this.$form.get()).then(() => {
        this.closeModal()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-show-faq {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 100px;
  justify-content: center;
  background: rgba(0, 0, 0, .2);

  .button-save {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .card-top {
    display: flex;
    align-items: center;
    justify-content: right;
  }
}
</style>
